import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { OrderProvider } from "@/context/OrderContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ScrollToTopButton } from "@/components/ScrollToTopButton";
import Home from "@/pages/Home";
import MenuBuilder from "@/pages/MenuBuilder";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Contact from "@/pages/Contact";
import { AlgemeneVoorwaarden, Allergenen, Privacy } from "@/pages/Legal";
import SubmitTori from "@/pages/SubmitTori";
import SuccessTori from "@/pages/SuccessTori";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function RequireAdmin({ children }) {
  const { authed } = useAuth();
  if (authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1B6B2E] text-white font-[600]" data-testid="admin-auth-checking">
        Laden...
      </div>
    );
  }
  if (!authed) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu-samenstellen" element={<MenuBuilder />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/bevestiging" element={<Confirmation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/deel-jouw-tori" element={<SubmitTori />} />
        <Route path="/tori-verstuurd" element={<SuccessTori />} />
        <Route path="/verhalen" element={<Stories />} />
        <Route path="/verhalen/:id" element={<StoryDetail />} />
        <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
        <Route path="/allergenen" element={<Allergenen />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Layout>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
      </Routes>
    );
  }
  return <PublicSite />;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <OrderProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <AppRoutes />
              <ScrollToTopButton />
            </BrowserRouter>
          </OrderProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
